import { useTheme } from '@automata/mui-theme';
import { TextField, Typography } from '@automata/ui';
import { ComponentProps } from 'react';

export const TextFieldWithMaxLength = ({
  value,
  maxLength,
  ...textFieldProps
}: ComponentProps<typeof TextField> & {
  maxLength?: number;
  value: string;
}): JSX.Element => {
  const theme = useTheme();

  const inputProps = textFieldProps.slotProps?.input ?? {};

  const maxLengthEndAdornment =
    maxLength !== undefined ? (
      <Typography
        variant="caption"
        color={
          value.length > maxLength
            ? theme.palette.error.main
            : theme.palette.text.secondary
        }
      >
        {value.length}/{maxLength}
      </Typography>
    ) : null;

  return (
    <TextField
      {...textFieldProps}
      value={value}
      slotProps={{
        ...textFieldProps.slotProps,
        input: {
          sx: {
            ...('sx' in inputProps ? inputProps.sx : undefined),
            gap: 1,
          },

          endAdornment:
            'endAdornment' in inputProps
              ? inputProps.endAdornment
              : maxLengthEndAdornment,
        },
      }}
    />
  );
};
